/**
 * @generated SignedSource<<bf364c836e786e910d8b0ecabc11c9df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AvailabilityAndPositionTypeFields_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AvailabilityBadge_User" | "AvailabilityEditDialog_User">;
  readonly " $fragmentType": "AvailabilityAndPositionTypeFields_User";
};
export type AvailabilityAndPositionTypeFields_User$key = {
  readonly " $data"?: AvailabilityAndPositionTypeFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvailabilityAndPositionTypeFields_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvailabilityAndPositionTypeFields_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvailabilityEditDialog_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvailabilityBadge_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "aeb74198fd6565b1023f181f0f70e986";

export default node;
